var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "recommend-event feature mb-40px tablet:mb-64px xl-pc:mb-88px"
};
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("h2", { class: "ttl-h2 text-white mb-21" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "flex flex-col tablet:flex-row items-start tablet:items-center" }, " 関連イベント "),
    /*#__PURE__*/ _createElementVNode("span", { class: "tag font-abo" }, "EVENTS")
], -1);
var _hoisted_3 = {
    key: 0,
    class: "cards-list tablet:mx-32px"
};
var _hoisted_4 = { class: "card card-full bg-white" };
var _hoisted_5 = ["href"];
var _hoisted_6 = { class: "thumb" };
var _hoisted_7 = ["src", "alt"];
var _hoisted_8 = { class: "flex flex-col flex-grow p-6 tablet:pt-0" };
var _hoisted_9 = { class: "mb-4 text-16px font-bold" };
var _hoisted_10 = { class: "mb-6 text-10px tablet:text-12px" };
var _hoisted_11 = { class: "hidden tablet:block" };
var _hoisted_12 = ["textContent"];
var _hoisted_13 = {
    key: 1,
    class: "cards-list tablet:mx-32px"
};
var _hoisted_14 = {
    href: "eventLink(reward)",
    class: "hover flex flex-col h-full"
};
var _hoisted_15 = { class: "thumb" };
var _hoisted_16 = ["src", "alt"];
var _hoisted_17 = { class: "flex flex-col flex-grow p-6" };
var _hoisted_18 = { class: "mb-4 text-16px font-bold" };
var _hoisted_19 = { class: "mt-auto mb-0 text-10px tablet:text-12px" };
var _hoisted_20 = {
    key: 2,
    class: "tablet:my-12 tablet:mx-32px text-white text-16px"
};
import { ref, onMounted } from 'vue';
import api from '../../modules/axios';
import { convertTimeFormat01 } from '../../utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FeatureEvents',
    props: {
        teamId: { type: String, required: true },
    },
    setup: function (__props) {
        var _this = this;
        var props = __props;
        var isLoading = ref(false);
        var rewards = ref(null);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isLoading.value = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.get("/communities/".concat(props.teamId, "/rewards?open=1&order=started_at%7Casc"))];
                    case 2:
                        result = _a.sent();
                        if (result.data.rewards) {
                            rewards.value = result.data.rewards;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        return [2 /*return*/, err_1];
                    case 4:
                        isLoading.value = false;
                        return [2 /*return*/];
                }
            });
        }); });
        var eventLink = function (reward) {
            return "https://engate.jp/communities/".concat(String(props.teamId), "/rewards/").concat(String(reward.id), "/");
        };
        return function (_ctx, _cache) {
            return (rewards.value && rewards.value.length === 1)
                ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
                    _hoisted_2,
                    (rewards.value && rewards.value.length === 1)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                            _createElementVNode("li", _hoisted_4, [
                                _createElementVNode("a", {
                                    href: eventLink(rewards.value[0]),
                                    class: "hover flex flex-col tablet:flex-row h-full",
                                    target: "_blank",
                                    ref: "noopenner"
                                }, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("img", {
                                            src: rewards.value[0].image,
                                            alt: String(rewards.value[0].title),
                                            class: "w-full"
                                        }, null, 8, _hoisted_7)
                                    ]),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("h4", _hoisted_9, _toDisplayString(String(rewards.value[0].title)), 1),
                                        _createElementVNode("p", _hoisted_10, "開催期間：" + _toDisplayString(_unref(convertTimeFormat01)(rewards.value[0].started_at)) + " 〜 " + _toDisplayString(_unref(convertTimeFormat01)(rewards.value[0].ended_at) || rewards.value[0].end_time_other), 1),
                                        _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("p", {
                                                class: "text-16px whitespace-pre-wrap line-clamp-5",
                                                textContent: _toDisplayString(rewards.value[0].description)
                                            }, null, 8, _hoisted_12)
                                        ])
                                    ])
                                ], 8, _hoisted_5)
                            ])
                        ]))
                        : (rewards.value && rewards.value.length > 1)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rewards.value, function (reward, i) {
                                    return (_openBlock(), _createElementBlock("li", {
                                        class: "card bg-white",
                                        key: "event-".concat(i)
                                    }, [
                                        _createElementVNode("a", _hoisted_14, [
                                            _createElementVNode("div", _hoisted_15, [
                                                _createElementVNode("img", {
                                                    src: reward.image,
                                                    alt: String(reward.title),
                                                    class: "w-full"
                                                }, null, 8, _hoisted_16)
                                            ]),
                                            _createElementVNode("div", _hoisted_17, [
                                                _createElementVNode("h4", _hoisted_18, _toDisplayString(String(reward.title)), 1),
                                                _createElementVNode("p", _hoisted_19, "開催期間：" + _toDisplayString(_unref(convertTimeFormat01)(reward.started_at)) + " 〜 " + _toDisplayString(_unref(convertTimeFormat01)(reward.ended_at) || reward.end_time_other), 1)
                                            ])
                                        ])
                                    ]));
                                }), 128))
                            ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_20, "開催中のイベントはありません。"))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
